import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  fontWeight600: {
    fontWeight: 600
  },
  icon: {
    fontSize: '22px',
    color: theme.palette.warning.main,
  },
  detailsLine: {
    whiteSpace: 'nowrap',
    '& span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }
  }
}));
